import {
  Filter,
  Filters,
} from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { ParsedQuery } from 'query-string'
import { FilterParam } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.types'
import { DashboardDateRangeDefaults } from 'src/components/Reusable/IndexPage/FilterBar/FilterDropdowns/DashboardFilterDropdowns/DashboardDateRangeFilterDropdown/DashboardDateRangeFilterDropdown.types'
import { queryParamAsArray } from '../queryParams'
import { daysToMillis } from '../globalHelpers'
import { DASHBOARD_TYPE_IS_AUDIT_SPECIFIC } from './dashboards.constants'
import { DashboardType } from './dashboards.types'

export const getIsDashboardAuditSpecific = (dname: string): boolean => {
  return DASHBOARD_TYPE_IS_AUDIT_SPECIFIC[dname as DashboardType] || false
}

export const getDashboardStepFromTimeBucket = (timeBucket: string): number => {
  switch (timeBucket) {
    case 'Daily':
      return daysToMillis(1)
    case 'Weekly':
      return daysToMillis(7)
    default:
      return daysToMillis(1)
  }
}

export const applyDashboardFilters = (
  filters: Filters,
  queryParams: ParsedQuery<string>,
  filterType: FilterParam,
): void => {
  const filterParams = queryParamAsArray(queryParams[filterType])

  if (!filterParams?.length) {
    return
  }

  switch (filterType) {
    case FilterParam.DASHBOARD_DEPARTMENT: {
      filters.addFilters(
        new Filter().setKey('department').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_FRAMEWORK: {
      filters.addFilters(
        new Filter().setKey('frameworks').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_POLICY: {
      filters.addFilters(
        new Filter().setKey('policies').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_AUDIT: {
      filters.addFilters(
        new Filter().setKey('audits').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_RISK: {
      filters.addFilters(
        new Filter().setKey('risks').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_ASSIGNEE: {
      filters.addFilters(
        new Filter().setKey('assignee').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_CONTROL: {
      filters.addFilters(
        new Filter().setKey('controls').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_RISK_CATEGORY: {
      filters.addFilters(
        new Filter().setKey('category').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_VENDOR: {
      filters.addFilters(
        new Filter().setKey('vendors').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_LABEL: {
      filters.addFilters(
        new Filter().setKey('labels').setValuesList(filterParams),
      )
      break
    }
    case FilterParam.DASHBOARD_DATE_RANGE: {
      switch (filterParams[0]) {
        case DashboardDateRangeDefaults.LAST_7_DAYS:
          filters.setStarttime(Date.now() - daysToMillis(7))
          break
        case DashboardDateRangeDefaults.LAST_30_DAYS:
          filters.setStarttime(Date.now() - daysToMillis(30))
          break
        case DashboardDateRangeDefaults.LAST_90_DAYS:
          filters.setStarttime(Date.now() - daysToMillis(90))
          break
        case DashboardDateRangeDefaults.LAST_YEAR:
          filters.setStarttime(Date.now() - daysToMillis(365))
          break
        default: {
          const dates = filterParams[0].split('-')
          const startMillis = parseInt(dates[0], 10)
          const endMillis = parseInt(dates[1], 10)
          filters.setStarttime(startMillis)
          filters.setEndtime(endMillis)
          break
        }
      }
      break
    }
    case FilterParam.DASHBOARD_NAME_DIMENSION:
      filters.addFilters(
        new Filter().setKey('name').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_EMAIL_DIMENSION:
      filters.addFilters(
        new Filter().setKey('email').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_COMPANY_DIMENSION:
      filters.addFilters(
        new Filter().setKey('org_name').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_DOC_NAME_DIMENSION:
      filters.addFilters(
        new Filter().setKey('doc_name').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_TP_FEATURE_DIMENSION:
      filters.addFilters(
        new Filter().setKey('features').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_TP_ACCESS_LEVEL_DIMENSION:
      filters.addFilters(
        new Filter().setKey('privacy_level').setValuesList(filterParams),
      )
      break
    case FilterParam.DASHBOARD_TP_UPDATE_CATEGORY_DIMENSION:
      filters.addFilters(
        new Filter().setKey('category').setValuesList(filterParams),
      )
      break
    default:
      break
  }
}
